import { useContext } from 'react'
import type { UndoContextValue } from './types'
import { UndoContext } from './UndoProvider'

// Read the undo service. Throws if used outside an `UndoProvider`.
export function useUndo(): UndoContextValue {
  const context = useContext(UndoContext)
  if (!context) throw new Error('useUndo must be used within an UndoProvider')
  return context
}
